
import { VoidRespondClient } from "../Models/RespondClient";
import { getInstance } from "./InstanceProvider";

export default class ContactUsProvider {
    public contactUsProvider: ContactUsProvider | undefined;

    public init() {
        if (!this.contactUsProvider) {
            this.contactUsProvider = new ContactUsProvider();
        }
    }

    public send(data: ContactUsModel): Promise<VoidRespondClient> {
        const host = process.env.REACT_APP_CONTACT_API_HOST;
        return getInstance().post(`${host}/email`, data);
    }
}

export type ContactUsModel = {
    email?: string,
    name?: string,
    body?: string
}

export const ContactUsProviderInstance = new ContactUsProvider();
